export const TextAttributeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5H17C18.1046 5 19 5.89543 19 7V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V7C5 5.89543 5.89543 5 7 5ZM7 6C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6H7ZM9 10.5V9.5C9 9.22386 9.22386 9 9.5 9H11.5V15H10.5C10.2239 15 10 15.2239 10 15.5C10 15.7761 10.2239 16 10.5 16H13.5C13.7761 16 14 15.7761 14 15.5C14 15.2239 13.7761 15 13.5 15H12.5V9H14.5C14.7761 9 15 9.22386 15 9.5V10.5C15 10.7761 15.2239 11 15.5 11C15.7761 11 16 10.7761 16 10.5V9.5C16 8.67157 15.3284 8 14.5 8H12.5H11.5H9.5C8.67157 8 8 8.67157 8 9.5V10.5C8 10.7761 8.22386 11 8.5 11C8.77614 11 9 10.7761 9 10.5Z"
        fill="#262E3D"
        fillOpacity="0.67"
      />
    </svg>
  );
};
